import * as React from 'react';
import cx from 'classnames';
import styles from './RateCardTable.css';
import isEmpty from 'lodash/isEmpty';
export default function RateCardTable(props) {
    const { rateCardTable, headers } = props;
    if (isEmpty(rateCardTable) || isEmpty(headers))
        return null;
    const tableCellClassName = `col-${12 / headers.length}-12`;
    return (<React.Fragment>
			<table className={cx(styles['rate-card-table'], styles['rate-card-table-content'])}>
				<thead className={styles['ratemap-header']}>
					<tr>
						{headers.map((header, i) => (<td key={`rate_card_${i}`} className={cx(styles['rate-table-data'], tableCellClassName)}>
								{header}
							</td>))}
					</tr>
				</thead>
				<tbody>
					{rateCardTable.map((contents, i) => {
        return (<tr key={`rate_card_${i}`}>
								{contents.map((content, j) => {
            return (<td key={`rate_card_table_${i}_${j}`} className={cx(styles['rate-table-data'], tableCellClassName, {
                [styles['highlight-text']]: content.bumpedUp
            })}>
											{content.value}
										</td>);
        })}
							</tr>);
    })}
				</tbody>
			</table>
		</React.Fragment>);
}
